import React, { useState } from 'react'
import st from './EmployeeSkill.module.scss'
import { ReactComponent as IconEdit } from 'components/Modules/User/Employee/img/edit-line.svg'
import { ReactComponent as IconArrow } from 'components/Modules/User/Employee/img/arrow-down-s-line.svg'

export default function EmployeeSkill(props) {
  const [open, setOpen] = useState(false)

  const arrayCreate = () => {
    const list = []
    if (props.info !== undefined && props.info.profile !== undefined) {
      if (props.info.profile[props.ts_key]?.length > 0) {
        props.info.profile[props.ts_key].forEach((item, index) => {
          list.push(<span key={index}>{item.name}</span>)
        })
      } else {
        list.push(<span key={1}>{props.translate.not_installed}</span>)
      }
      return list
    }
  }

  return (
    <div className={st.employeeSkill}>
      <div className={st.title}>{props.title}:</div>
      {open ? <div className={st.info}>{arrayCreate()}</div> : <div />}
      <div className={st.buttons}>
        {open && props.editable && (
          <div
            className={`${st.btn} ${st.btnEdit}`}
            onClick={() => props.modal(props.ts_key)}
          >
            <IconEdit />
          </div>
        )}
        <div
          className={`${st.btn} ${open ? st.btnClose : st.btnOpen}`}
          onClick={() => setOpen(!open)}
        >
          <IconArrow />
        </div>
      </div>
    </div>
  )
}
